import React from 'react';
import { Input } from 'antd';
import { FiCopy } from 'react-icons/fi';
import { successAlert } from '@components/toastify/notify-toast';

interface RequestBodyEditorProps {
    value: string;
    onChange: (value: string) => void;
}

/*
 * Plain textarea for editing the Try It Out request body, with a copy-to-clipboard action.
 */
export function RequestBodyEditor({ value, onChange }: RequestBodyEditorProps) {
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            successAlert('Copied to clipboard.');
        } catch {
            // Clipboard API unavailable — nothing further to do.
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <label style={{ color: '#c7c7cd' }}>Request Body</label>
                <FiCopy onClick={copy} style={{ cursor: 'pointer' }} />
            </div>
            <Input.TextArea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                rows={8}
                style={{ fontFamily: 'monospace', fontSize: 12 }}
            />
        </div>
    );
}
